import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../../models/security/user';

@Pipe({
	name: 'filterUsersByEmployeeName'
})
export class FilterUsersByEmployeeNamePipe implements PipeTransform {
	transform(users: User[], filter: string): User[] {
		if (users === null || filter === '') {
			return users;
		}

		return users.filter((user: User) => {
			if (user.firstName !== null && user.lastName !== null) {
				return (user.firstName + user.lastName)
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase()
					.includes(
						filter
							.normalize('NFD')
							.replace(/[\u0300-\u036f]/g, '')
							.toLowerCase()
					);
			}
			return false;
		});
	}
}
